import React, { useContext } from 'react'
import LeftContent from 'modules/react/signup/LeftContent'
import RightContent from 'modules/react/signup/RightContent'
import SignupContext from 'modules/react/signup/SignupContext'
import FormElementError from 'modules/react/signup/FormElementError'
import CourseSummary from 'modules/react/signup/CourseSummary'
import CourseDateSelection from 'modules/react/signup/CourseDateSelection'
import NewsletterCheckbox from 'modules/react/signup/NewsletterCheckbox'

export default function Step2Employed () {

  const signupContext = useContext(SignupContext)
  const { goBack, goToStep, setFormValue, submit, step, restUrls, setEnterCallback } = signupContext

  const [paymentType, setPaymentType] = React.useState(null)
  React.useEffect(() => {
    setEnterCallback(() => validateStepData)
  }, [])
  const [paymentString, setPaymentString] = React.useState('Vælg betaling')

  React.useEffect(() => {
    setEnterCallback(() => validateStepData)
  }, [])

  const validateStepData = () => {
    if (paymentType === 'company') {
      submit(restUrls.employed.validate_personal)
        .then((response) => {
          goToStep(step + 1)
        })
    }

    if (paymentType === 'self') {
      submit(restUrls.employed.signup)
        .then((response) => {
          goToStep(step + 2)
        })
    }
  }

  React.useEffect(() => {
    setFormValue('payment_type', paymentType)
    if (paymentType === 'company') {
      setPaymentString('Virksomhed')
    } else {
      setPaymentString('Egenbetaling')
    }

  }, [paymentType])

  return (<>
      <LeftContent>
        <div className="title title--h3">Tilmelding</div>
        <div className="wysiwyg">Du har valgt at tilmelde dig et Premium kursus
          For at vi kan registrere din tilmelding har vi brug
          for følgende oplysninger:
        </div>
        <CourseDateSelection/>
        <div className="title title--h6">Udfyld dine oplysninger</div>
        <div className="input-group">
          <div className="input-group__half">
            <div className="input-wrap">
              <FormElementError name="firstName">
                <input type="text" placeholder="Dit fornavn:" onChange={(e) => setFormValue('firstName', e.target.value)}/>
              </FormElementError>
            </div>
            <div className="input-wrap">
              <FormElementError name="lastName">
                <input type="text" placeholder="Dit efternavn:" onChange={(e) => setFormValue('lastName', e.target.value)}/>
              </FormElementError>
            </div>
          </div>
          <div className="input-wrap">
            <FormElementError name="cpr">
              <input type="text" placeholder="CPR-nr:"
                     onChange={(e) => setFormValue('cpr', e.target.value)}/>
            </FormElementError>
          </div>
          <div className="input-group__half">
            <div className="input-wrap">
              <FormElementError name="phone">
                <input type="text" placeholder="Dit telefonnr:"
                       onChange={(e) => setFormValue('phone', e.target.value)}/>
              </FormElementError>
            </div>
            <div className="input-wrap">
              <FormElementError name="email">
                <input type="text" placeholder="Din email:"
                       onChange={(e) => setFormValue('email', e.target.value.trim())}/>
              </FormElementError>
            </div>
          </div>
        </div>

        <div className="title title--h6">Hvem skal betale?</div>
        <div className="input-group radio-group">
          <div className="radio-button">
            <input type="radio" id="company" name="payment_type" value="company"
                   onChange={() => setPaymentType('company')}/>
            <label htmlFor="company">Min virksomhed</label>
          </div>
          <div className="radio-button">
            <input type="radio" id="self" name="payment_type" value="self" onChange={() => setPaymentType('self')}/>
            <label htmlFor="self">Det skal jeg selv</label>
          </div>
        </div>
        <NewsletterCheckbox/>
        <div className="button-section button-section--modal-group">
          <button className="inline-button inline-button--prim inline-button--back" onClick={goBack}>Tilbage
          </button>
          <button className="button button--next" disabled={paymentType === null} onClick={validateStepData}>Tag mig
            videre
          </button>
        </div>
      </LeftContent>
      <RightContent>
        <CourseSummary paymentType={paymentString}/>
      </RightContent>
    </>)
}